import React, {useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { REGISTER_URL, getHeadline } from '../pricing';
import Hero from './sections/Hero';
import Introduction from './sections/Introduction';
import Problems from './sections/Problems';
import Solution from './sections/Solution';
import Schedule from './sections/Schedule';
import TravelDetails from './sections/TravelDetails';
import Preparation from './sections/Preparation';
import Testimonials from './sections/Testimonials';
import TargetGroups from './sections/TargetGroups';
import Pricing from './sections/Pricing';
import FAQ from './sections/FAQ';
import Registration from './sections/Registration';
import Navigation from './Navigation';

const {FiArrowUp, FiMapPin} = FiIcons;

const LandingPage = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showStickyBar, setShowStickyBar] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
      setShowStickyBar(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-amber-50">
      <Navigation />
      <main className={showStickyBar ? 'pb-20' : ''}>
        <Hero />
        <Introduction />
        <Problems />
        <Solution />
        <Schedule />
        <TravelDetails />
        <Preparation />
        <Testimonials />
        <TargetGroups />
        <Pricing />
        <FAQ />
        <Registration />
      </main>

      {/* Sticky Registration Bar */}
      <motion.div
        initial={{y: 100, opacity: 0}}
        animate={{y: showStickyBar ? 0 : 100, opacity: showStickyBar ? 1 : 0}}
        transition={{duration: 0.3}}
        className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
          <div className="hidden sm:block">
            <p className="text-sm font-semibold text-gray-900">{getHeadline() ? `${getHeadline()} · จำกัด 36 ท่าน` : 'ปิดรับลงทะเบียนแล้ว'}</p>
            <p className="text-xs text-gray-500">19 พ.ย. 2569 · เกาะสีชัง</p>
          </div>
          <a
            href={REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 sm:flex-none inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-bold rounded-full hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-md"
          >
            <SafeIcon icon={FiMapPin} className="w-5 h-5 mr-2" />
            ลงทะเบียนเลย
          </a>
        </div>
      </motion.div>

      {/* Scroll to Top Button */}
      <motion.button
        initial={{opacity: 0, scale: 0}}
        animate={{opacity: showScrollTop ? 1 : 0, scale: showScrollTop ? 1 : 0}}
        transition={{duration: 0.3}}
        onClick={scrollToTop}
        className="fixed bottom-24 right-4 sm:bottom-8 sm:right-8 bg-gradient-to-r from-red-600 to-red-700 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-50"
      >
        <SafeIcon icon={FiArrowUp} className="w-6 h-6" />
      </motion.button>
    </div>
  );
};

export default LandingPage;